import React, { useEffect, useState } from 'react'
import { NavBar, Toast } from 'antd-mobile'
import axios from 'axios';
import API_ROUTES from '../../api';
import { useNavigate } from 'react-router-dom';
import GameListContainer from '../GameListContainer';


export default function ApplicateList() {

    const navigate = useNavigate()
    const [gameList, setGameList] = useState([])


    useEffect(() => {
        getGameInfo()
    }, []);

    const getGameInfo = () => {
        Toast.show({
            icon: 'loading',
        })
        axios.get(API_ROUTES.game_list, {
            params: {
                count: -1,
                status: 1
            }
        })
            .then(function (response) {
                Toast.clear()
                setGameList(response.data.data)
            })
            .catch(function (error) {
                console.error('Error fetching user list:', error);
            })
            .finally(() => {

            });
    }

    return (
        <div className="applicate-container has-unified-nav ui-page ui-page--with-nav">
            <NavBar
                className="unified-navbar fixed"
                onBack={() => navigate('/home')}
            >
                比赛列表
            </NavBar>
            <div className='body_detail ui-page__content'>
                <GameListContainer gameList={gameList} navigateUrl="/applicateTwo" />
            </div>
        </div>
    )
}
